import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import LoadingSpinner from 'static/three-oh/src/components/LoadingSpinner/LoadingSpinner';

const LazyAssignmentsContainer = Loadable({
  loader: () => import(
    /* webpackChunkName: "AssignmentsContainer" */
    './containers/AssignmentsContainer'
  ),
  loading: LoadingSpinner,
});


const AssignmentsRoute = (
  <Route
    component={LazyAssignmentsContainer}
    key="assignments"
    path="/assignments"
  />
);

export default AssignmentsRoute;
